import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Button, Label, Icon} from 'semantic-ui-react';
import {Actions} from '../../common/actions';
import ReplaceModal from './modals/replaceModal';
import SaveChangesModal from './modals/saveChangesModal';
import AddPartFilesModal from './modals/addPartFilesModal';
import MassUploadModal from './modals/massUploadModal';

class FormHeader extends Component {
  handleNewClick = () => {
    this.props.restorePartsFormValues();
  }

  renderText = () => {
    const {partCode, haveFiles} = this.props;
    const partText = partCode ? ` | ${partCode}` : '';

    return (
      <span className='title'>
        <h2>Maestro de Partes {partText}</h2>
        {haveFiles === 'S' ? (
          <Label className='saved-files' color='green' size='large'>
            <Icon name='check' />
            Archivos MSDS
          </Label>
        ) : null}
      </span>
    );
  }

  renderNewButton = () => {
    const {wasSaved} = this.props;

    if (wasSaved) {
      return (
        <Button secondary type='button' onClick={this.handleNewClick}>
          CREAR NUEVO
        </Button>
      );
    }

    return null;
  }

  render() {
    const {
      loading,
      loadingRejection,
      openConfirmation,
      partCode,
      isUserTde,
      wasSaved,
      wasSearched,
      loadingAttachments,
      rawAttachments,
      attachments,
    } = this.props;
    const loadingStatus = loading || loadingRejection;
    
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width='7' textAlign='left'>
            <ReplaceModal trigger={this.renderText()} />
          </Grid.Column>
          <Grid.Column width='9' textAlign='right'>
            {this.renderNewButton()}
            
            <MassUploadModal />

            <AddPartFilesModal
              partCode={partCode}
              wasSearched={wasSearched}
              wasSaved={wasSaved}
              isUserTde={isUserTde}
              loadingAttachments={loadingAttachments}
              rawAttachments={rawAttachments}
              attachments={attachments}
            />
            <SaveChangesModal
              open={openConfirmation}
              trigger={
                <Button
                  primary
                  type='submit'
                  disabled={loadingStatus}
                  loading={loadingStatus}
                >
                  GUARDAR
                </Button>
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, loading, loadingRejection, wasSaved, openConfirmation, wasSearched} =
    state.partsMaster || {};
  const {partCode, partName, haveFiles} = values || {};

  return {
    partCode,
    partName,
    loading,
    loadingRejection,
    wasSaved,
    haveFiles,
    wasSearched,
    openConfirmation,
    'isUserTde': state.session.isUserFromTDE,
    'loadingAttachments': state.partsMaster.loadingAttachments,
    'rawAttachments': state.partsMaster.rawAttachments,
    'attachments': state.partsMaster.attachments,
  };
};

const {restorePartsFormValues} = Actions;

export default connect(mapStateToProps, {restorePartsFormValues})(FormHeader);
